/*
 * App.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

import React from 'react'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import './App.css'
import MainRouter from './config/routes/MainRouter'
import { queryClient } from './config/reactQuery/reactQuery'
import UpdateDialog from './component/general/UpdateDialog'
import { localization } from './config/localize/localizable'
import Loading from './component/general/Loading'

function App() {
    localization.setLanguage('fa-IR')

    return (
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <button id="install_button" hidden className=" w-full text-white bg-red-500 p-2">
                    نصب PWA
                </button>

                <UpdateDialog />

                <MainRouter />
                <Toaster position="top-center" reverseOrder={false} />
                <Loading />
                <ReactQueryDevtools />
            </QueryClientProvider>
        </BrowserRouter>

        // <div className="App">

        //   <header className="App-header">
        //     <img src={logo} className="App-logo" alt="logo" />
        //     <p>
        //       Edit <code>src/App.js</code> and save to reload.
        //     </p>
        //     <a
        //       className="App-link"
        //       href="https://reactjs.org"
        //       target="_blank"
        //       rel="noopener noreferrer"
        //     >
        //       Learn React
        //     </a>
        //   </header>
        // </div>
    )
}

export default App
